<template lang="html">
  <!--
  Component to render <input> element
  - Accepts the following properties:
  [id, type, name, placeholder, required, value]

  - Accepts optional callback property:
  [on-text-input-change, on-text-input-focus, on-text-input-blur]

  @example

  <TextInput
    ref="test1"
    id="pwd"
    type="password"
    placeholder="Enter password"
    required="true"
    @on-text-input-focus="onTextInpuFocus"
    @on-text-input-blur="onTextInputBlur"
    @on-text-input-change="onTextInputChanged"/>

  -->

  <section>
    <div class="m-text-input">
      <label v-if="label" class="m-text-input__label">{{ label }}</label>
      <input
        ref="inputElement"
        class="m-input"
        v-model="model"
        :id="id"
        :type="type"
        :name="name"
        :placeholder="placeholder"
        :required="required"
        @focus="onInputFocus"
        @blur="onInputBlur"
        @click="onInputFocus"
      />
    </div>
  </section>
</template>

<script lang="js">

  export default {
    name: "text-input",
    props: {
      /**
       * input properties
       * @values id, type, name, placeholder, value, required
       */
      id: {
        type: String
      },
      type: {
        type: String
      },
      name: {
        type: String
      },
      placeholder: {
        type: String
      },
      value: {
        type: String
      },
      required: {},
      label: {
        type: String
      }
    },
    data() {
      return {
        model: ""
      }
    },
    watch: {
      value: {
        handler() {
          this.model = this.value;
        },
        immediate: true
      },
      model: function () {
        /**
         * Triggers when model value changes
         */
        const EVENT = "on-text-input-change";
        if(this.$listeners[EVENT] || this._events[EVENT]) {
          this.$emit(EVENT, this.model);
        }
      }
    },
    methods: {
      onInputFocus() {
        /**
         * Triggers when model value changes
         */
        const EVENT = "on-text-input-focus";
        if(this.$listeners[EVENT] || this._events[EVENT]) {
          this.$emit(EVENT, this.model);
        }
      },
      onInputBlur() {
        /**
         * Triggers when model value changes
         */
        const EVENT = "on-text-input-blur";
        if(this.$listeners[EVENT] || this._events[EVENT]) {
          this.$emit(EVENT, this.model);
        }
      },
      /**
       * @function getValue
       * @returns {String} value of model
      */
      getValue() {
        return this.model;
      },
      /**
       * @function getMetadata
       * @returns {Object} Metadata in JSON format
      */
      getMetadata() {
        return {
          name: this.$options.name,
          type: this.type,
          value: {
            type: "literal",
            value: this.model
          }
        };
      }
    }
  };
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  @include drag-drop-a-tag;
  .m-text-input {
    display: flex;
    flex-direction: column;
  }
  .m-input {
    @include drag-drop-text-input;
  }
  .m-text-input__label {
    @include mixin-label;
  }
</style>
